import translations from "../translations/resources/en-GB.json";
export var ERROR_MESSAGE = {
    409: {
        message: translations.data["venonboard.internalTools.CreateDraft409Error"],
    },
    503: {
        message: translations.data["venonboard.internalTools.CreateDraftMessageError"],
    },
    SERVICE_DOWN: {
        message: "Service unavailable, please try again later",
    },
    DEFAULT: {
        message: translations.data["venonboard.internalTools.CreateDraftMessageError"],
    },
};
export var ORG_TENANT = {
    INTERNAL: "Internal",
    EXTERNAL: "External",
};
